var exports = {
  "kL": "x0a7806d5--7f6700--container",
  "UU": "x0a7806d5--7f6700--name",
  "FI": "x0a7806d5--7f6700--parameters",
  "md": "x0a7806d5--7f6700--construction-time",
  "q9": "x0a7806d5--7f6700--price",
  "WD": "x0a7806d5--7f6700--labels",
  "h_": "x0a7806d5--7f6700--description",
};

module.exports = exports;
